// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Premium = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Premium = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  var Premium = _exports.Premium = function Premium(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", {
      width: "14",
      height: "14",
      viewBox: "0 0 14 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/_react["default"].createElement("rect", {
      width: "14",
      height: "14",
      rx: "3",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.2498 10.3538C5.24922 10.3538 5.24863 10.3538 5.24805 10.3538C5.13138 10.3532 5.01997 10.3065 4.93772 10.2231L2.60438 7.85362C2.43463 7.68154 2.43697 7.40447 2.60905 7.23472C2.78113 7.06555 3.0588 7.0673 3.22797 7.23938L5.25155 9.29504L10.7734 3.77321C10.9443 3.60229 11.2214 3.60229 11.3923 3.77321C11.5632 3.94412 11.5632 4.22123 11.3923 4.39214L5.55897 10.2255C5.4773 10.3077 5.36588 10.3538 5.2498 10.3538Z",
      fill: "white",
      stroke: "#212B36",
      "stroke-width": "0.35"
    }));
  };
});
